// 프로젝트·경력 데이터. 항목 추가는 여기서만 하면 된다.
// PROJECTS 는 최신순(위가 가장 최근). 화면의 01/02/03 번호는 이 순서에서 자동 계산된다.
//
// shortId: 유튜브 쇼츠 영상 ID. 넣으면 썸네일 위에 재생 버튼이 생긴다.
//   https://www.youtube.com/shorts/dQw4w9WgXcQ  ->  shortId: 'dQw4w9WgXcQ'
//   null 이면 버튼이 안 보인다.

export const PROJECTS = [
  {
    id: 'ilsang',
    name: '일상정비소',
    desc: '치과 검진, 침구 교체, 냉장고 청소. 중요한데 자꾸 밀리는 것들을 기억하고 알려줘요.',
    status: 'iOS TESTFLIGHT',
    statusType: 'beta',
    image: '/ilsang_screenshot.png',
    shortId: 'u-XoNHD-xK8',
    links: [{ label: 'ilsang-homepage.vercel.app', href: 'https://ilsang-homepage.vercel.app/' }],
  },
  {
    id: 'farawaydiary',
    name: '먼나라 다이어리',
    desc: '닿을 곳 없는 당신의 밤, 우주로 송출하세요.',
    status: 'OPEN BETA',
    statusType: 'beta',
    image: '/farawaydiary_screenshot.png',
    shortId: '8Leezr0bGME',
    links: [
      {
        label: 'Google Play',
        href: 'https://play.google.com/store/apps/details?id=com.munnara.diary',
      },
      { label: 'Instagram', href: 'https://www.instagram.com/farawaydiary.official/' },
      { label: 'farawaydiary.com', href: 'https://www.farawaydiary.com/' },
    ],
  },
  {
    id: 'myhanbok',
    name: '마이한복',
    desc: '내 사진 한 장으로 다양한 한복 화보를.',
    status: 'LIVE',
    statusType: 'live',
    image: '/Myhanbok_screenshot.png',
    shortId: null,
    links: [{ label: 'myhanbok.kr', href: 'https://www.myhanbok.kr/' }],
  },
];

export const CAREER = [
  {
    period: '2026 —',
    place: 'LittleWins',
    detail: '1인 앱 스튜디오 · 기획, 개발, 디자인',
  },
  {
    period: '2024',
    place: '잉글리간식',
    detail: '영어교육 유튜브 · 최고 구독자 11,800명',
  },
  {
    period: '2004 — 2023',
    place: 'NCSOFT',
    detail:
      '게임 기획 · PD — MMORPG 아이온1, 모바일 RPG 블레이드앤소울 모바일, 모바일 퍼즐게임 아라미퍼즈벤처',
  },
];

export const CONTACT_LINKS = [
  { label: 'jieun@littlewins.kr', href: 'mailto:jieun@littlewins.kr' },
  { label: 'Threads', href: 'https://www.threads.net/@littlewins_log' },
  { label: 'X', href: 'https://x.com/littlewins_log' },
];

export const NAV_LINKS = [
  { href: '#projects', label: '프로젝트' },
  { href: '#maker', label: '만드는 사람' },
  { href: '#contact', label: '연락' },
];
